import React from 'react';
import { ManageFee } from '../components';

export default () => {
    return (
        <ManageFee.Home />
    )
}